module.exports = __webpack_public_path__ + "img/app_icon.9c8480bc.png";